import { isInvalidData, setValue, getValue, unsetValue, parser, isObject } from "./util"
import { eventBus } from '@sm/max-common'
import { validate } from "../../utils/validate"

const eventbus = eventBus.create()
const uniqueStorageKey = '__uniqueStorageKey__'

window.addEventListener('storage', (event) => {
  const _key = `${uniqueStorageKey}${event.key}`
  eventbus.send(_key, event.newValue)
})

function handleKey(key: string): [primaryKey: string, keys: string[]] {
  let primaryKey = key
  let keys: string[] = []
  if (key.indexOf(".") > -1) {
    ;[primaryKey, ...keys] = key.split(".")
  }
  return [primaryKey, keys]
}
export const storage = {
  init(): void { },
  /**
   * 获取缓存，key为obj.a.b情况通过getValue获取数据
   * @param key 获取storage的关键值
   */
  get(key: string): unknown | undefined {
    if (!key?.length) throw "Invalid storage key"
    let [primaryKey, keys] = handleKey(key)
    let result: any = localStorage.getItem(primaryKey) ?? undefined
    result = parser(result)
    if (keys?.length) {
      result = getValue(result, keys.join("."))
    }
    return result
  },
  /**
   * 设置缓存，
   * @param key 设置storage关键值
   * @param value storage值内容
   */
  set(key: string, value: unknown): boolean {
    if (!key?.length) throw "Invalid storage key"
    let [primaryKey, keys] = handleKey(key)
    if (isInvalidData(value)) {
      localStorage.removeItem(primaryKey)
    } else {
      if (keys?.length) {
        let result = localStorage.getItem(primaryKey) || {}
        result = parser(result)
        value = setValue(result, keys, value)
      }
      try {
        localStorage.setItem(primaryKey, JSON.stringify(value))
      } catch (error) {
        throw new Error(error)
      }
    }
    return true
  },
  /**
   * 删除本地缓存值
   * @param key 需要删除值的key
   */
  remove(key: string): boolean {
    if (!key?.length) throw "Invalid storage key"
    let [primaryKey, keys] = handleKey(key)
    if (keys?.length) {
      let result = storage.get(primaryKey)
      result = unsetValue(result, keys.join("."))
      storage.set(primaryKey, result)
    } else {
      localStorage.removeItem(key)
    }
    return true
  },
  /**
   * 清空本地缓存
   */
  clear(): boolean {
    localStorage.clear()
    return true
  },
  addListener(key: string, callback: (newValue: any) => void) {
    validate.String(key, 'key')
    if (typeof callback !== 'function') {
      throw Error('"callbak" must be a function.')
    }
    const _key = `${uniqueStorageKey}${key}`
    eventbus.addListener(_key, callback)
  },
  removeListener(key: string, callback?: (param: unknown) => void) {
    validate.String(key, 'key')
    const _key = `${uniqueStorageKey}${key}`
    eventbus.removeListener(_key, callback)
  }
} as LocalStorageDSL

export const token = {
  key: "__token__",
  get(): Record<string, string> | string | undefined | null {
    return storage.get(token?.key)
  },
  set(value: any) {
    // 兼容 token 的写法
    if (isObject(value) && 'token' in value) {
      value['x-token'] = value['token']
    }
    storage.set(token.key, value)
    return true
  },
  addTokenListener(callback: (newValue: any) => void) {
    storage.addListener(token.key, callback)
  },
  removeTokenListener(callback?: (param: unknown) => void) {
    storage.removeListener(token.key, callback)
  }
}

export const store = {
  key: "__store__",
  get(): Record<string, string> | string | undefined | null {
    return storage.get(store?.key)
  },
  set(value: unknown) {
    storage.set(store.key, value)
    return true
  }
}

// export const newStorage = {
//   get(key: string) {
//     return storage.get(key)
//   },
//   set(key: string, value: unknown) {
//     return storage.set(key, value)
//   },
//   remove(key: string): boolean {
//     return storage.remove(key)
//   },
//   clear(): boolean {
//     return storage.clear()
//   },
// }